export const shadows = {
  // override the default blue outline seen on many components
  outline: "0 0 0 1px rgba(209, 209, 214, 0.6)",
};
